
import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { EventFormValues } from '../../schemas/eventFormSchema';

interface UseFormWatchersProps {
  form: UseFormReturn<EventFormValues>;
  onFormChanged?: (isDirty: boolean) => void;
}

export const useFormWatchers = ({ form, onFormChanged }: UseFormWatchersProps) => {
  // Watch the form for changes to update dirty state
  useEffect(() => {
    if (onFormChanged) {
      const subscription = form.watch(() => {
        const isDirty = form.formState.isDirty;
        onFormChanged(isDirty);
      });

      return () => subscription.unsubscribe();
    }
  }, [form, onFormChanged]);

  // Watch online/offline toggle
  useEffect(() => {
    const subscription = form.watch((value, { name }) => {
      // Handle online/offline toggle
      if (name === 'isOnline') {
        if (value.isOnline) {
          // When switching to online, save offline values but don't display them
          form.setValue('eventUrl', form.getValues('eventUrl') || 'https://', { shouldDirty: true });
        }
      }
    });

    return () => subscription.unsubscribe();
  }, [form]);
};
